import { useState, FormEvent } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Button, Modal, Form, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStamp } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { DraggableModalDialog } from '../../../Dialogs/DraggableModalDialog';
import HTMLReport from '../../Reporting/HTMLReport';

export interface BlockStampDetailsDialogProps {
    initialBlockCode: string,
    initialBlockMessage: string,
    showDialog: boolean,
    closeDialog: () => void,
    onSave: (blockCode: string, blockMessage: string) => void
}

function BlockStampDetailsDialog({ initialBlockCode, initialBlockMessage, showDialog, closeDialog, onSave }: BlockStampDetailsDialogProps) {
    const { t } = useTranslation();
    const [blockCode, setBlockCode] = useState(initialBlockCode);
    const [blockMessage, setBlockMessage] = useState(initialBlockMessage);

    const handleSave = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();

        onSave(blockCode, blockMessage);
        closeDialog();
    }

    return (
        <Modal dialogAs={DraggableModalDialog} show={showDialog} onHide={closeDialog} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{t("Dialogs.BlockStampDetails.Title")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSave} id="commentForm">
                    <Form.Group as={Row} className="mb-2">
                        <Form.Label column sm={2}>{t("Dialogs.BlockStampDetails.BlockCode")}</Form.Label>
                        <Col sm={10}>
                            <Form.Control type="text" placeholder={t("Dialogs.BlockStampDetails.BlockCode")} onChange={(e) => setBlockCode(e.target.value)} value={blockCode} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-2">
                        <Form.Label column sm={2}>{t("Dialogs.BlockStampDetails.BlockMessage")}</Form.Label>
                        <Col sm={10}>
                            <Form.Control as="textarea" autoFocus rows={6} onChange={(e) => setBlockMessage(e.target.value)} value={blockMessage} />
                        </Col>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeDialog}>
                    {t("Application.Controls.Close")}
                </Button>
                <Button variant="primary" type="submit" form="commentForm">
                    {t("Application.Controls.Save")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default function RecipeReport() {
    const { t } = useTranslation();
    const { lotNumber } = useParams();

    let initialUrl = `api/v1/lot/${lotNumber}/lotdetailsreport`;

    const [showBlockStampDetailsDialog, setShowBlockStampDetailsDialog] = useState(false);
    const [url, setUrl] = useState(initialUrl);
    const [blockCode, setBlockCode] = useState("");
    const [blockMessage, setBlockMessage] = useState("");

    const handleBlockStampDetailsSave = (blockCode: string, blockMessage: string) => {
        let newUrl = `api/v1/lot/${lotNumber}/lotdetailsreport?blockCode=${blockCode}&blockMessage=${blockMessage}`;

        setBlockCode(blockCode);
        setBlockMessage(blockMessage);

        setUrl(newUrl);
    }

    let downloadName = `${lotNumber}-details-report.html`;

    return (
        <>
            <Container>
                <div className="d-inline-flex me-3">
                    <Button className="me-1" onClick={() => setShowBlockStampDetailsDialog(true)}><FontAwesomeIcon icon={faStamp} className="me-1" />{t("Dialogs.BlockStampDetails.AddButton")}</Button>
                </div>
            </Container>
            <BlockStampDetailsDialog initialBlockCode={blockCode} initialBlockMessage={blockMessage} showDialog={showBlockStampDetailsDialog} closeDialog={() => setShowBlockStampDetailsDialog(false)} onSave={handleBlockStampDetailsSave} />

            <HTMLReport url={url} downloadName={downloadName}></HTMLReport>
        </>
    )
}
